export default {
    event: 'Event',
    mailing: 'Email',
    sms: 'SMS',
};
